import { useApiQuery } from 'mf_core/query';
import { useSiteConfig } from 'mf_core/config';

export function useVoucherCountAPI() {
  const { siteCode } = useSiteConfig();
  return useApiQuery<VoucherCount>('/checkout/v1/vouchers/count', undefined, {
    enabled: voucherEnabledCountries[siteCode] || false,
    refetchOnWindowFocus: false,
  });
}

export type VoucherCount = {
  count: number;
};

const voucherEnabledCountries: { [country: string]: boolean } = {
  at: true,
  ch: true,
  de: true,
  dk: true,
  es: true,
  fi: true,
  fr: true,
  gb: true,
  hu: true,
  it: true,
  pt: true,
  se: true,
};
